import React from 'react';

export default function FieldDropdown_FormValueEmpty(props:any) {

    if (props.field.noValueOption) {

        const classes = Classes("ui5-txt-default", "ui5-field-form-editable", "dropdown-form", "h-36", props.className, {
            "is-disabled": props.disabled
        })
        const valueClasses = Classes({
            "ui5-txt-default"           : !props.disabled,
            "ui5-txt-no-accent-default" : props.disabled
        })

        return (
            <React.Fragment>
                <div className  = {classes}
                     onClick    = {props.onClick}>

                    {_.get(props.field.components, 'ValueIcon', false)}

                    <span className = {valueClasses}>
                        {props.field.noValueOptionLabel}
                    </span>
                </div>

                {props.children}

            </React.Fragment>
        )

    } else {

        const size = _.get(props.configOptions, 'size', '36')

        const classes = Classes("ui5-field-form-editable dropdown-form", 'h-{0}'.f(size), props.className)

        return (
            <React.Fragment>
                <div className={classes} onClick={props.onClick}>
                    {_.get(props.field.components, 'ValueIcon', false)}
                    <div className="ui5-txt-no-accent-default txt-truncate">{props.field.placeholder}</div>
                </div>
                {props.children}
            </React.Fragment>
        )
    }

}